import createDependenciesCollector from "./utils/create-dependencies-collector";

const getForJoint = createDependenciesCollector(["PositiveSelectionV2"]);

export default getForJoint;
